"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasketEndpointRequest = exports.basketWithQueryParameter = void 0;
const attributes_1 = require("../../helpers/attributes");
const ProductWith_1 = require("../../types/ProductWith");
function basketWithQueryParameter(basketWith) {
    var _a;
    const withParams = [];
    if (basketWith.items && basketWith.items.product) {
        withParams.push(...(0, ProductWith_1.productWithQueryParameterValues)(basketWith.items.product).map(value => `items.product.${value}`));
    }
    if (basketWith.items && basketWith.items.variant) {
        withParams.push(...(0, attributes_1.prefixList)(`items.variant.`)((0, ProductWith_1.variantWithQueryParameterValues)(basketWith.items.variant)));
    }
    if (((_a = basketWith.items) === null || _a === void 0 ? void 0 : _a.promotion) === true) {
        withParams.push('items.promotion');
    }
    if (basketWith.applicablePromotions === true) {
        withParams.push('applicablePromotions');
    }
    return withParams;
}
exports.basketWithQueryParameter = basketWithQueryParameter;
function getBasketEndpointRequest(params) {
    return {
        method: 'GET',
        endpoint: `baskets/${params.basketKey}`,
        params: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (params.with
            ? { with: basketWithQueryParameter(params.with).join(',') }
            : undefined)), (params.campaignKey ? { campaignKey: params.campaignKey } : undefined)), (params.checkoutShopId
            ? { checkoutShopId: params.checkoutShopId }
            : undefined)), (params.skipAvailabilityCheck
            ? { skipAvailabilityCheck: params.skipAvailabilityCheck }
            : undefined)), (params.includeItemsWithoutProductData
            ? {
                includeItemsWithoutProductData: params.includeItemsWithoutProductData,
            }
            : undefined)),
    };
}
exports.getBasketEndpointRequest = getBasketEndpointRequest;
